import { API_END_POINTS } from "../../constant/config";
// import JsonInterceptor from "../../utils/JsonInterceptor";
import {FETCH_ACTIVITIES} from "../type";
import axios from "axios";
import JsonInterceptor from "../../utils/JsonInterceptor";
import Filter from "../../utils/Filter";
// Fetch Wix Categories
export const fetchActivities = (query) => async (dispatch) => {
    try {
        console.log(query)
        const search = (query.search===undefined||query.search==="") ? "":query.search;
        const apiEndpoint = `${API_END_POINTS.FETCH_ACTIVITY}?page=${query.pageNumber}&limit=${query.pageSize}&search=${search}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.data.docs,query);
        console.log(response)

        dispatch({
            type: FETCH_ACTIVITIES,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};



